import ServicesForm from "../../../../components/forms/servicesform/index"
const UpdateService = () => {
    return (
        <div>
            <ServicesForm title="Fill to Update Services Profile" btn="update" url="/services-profile" back="/services-profile/" link="/update-service/" />
        </div>
    )
}
export default UpdateService;